import React from 'react';
import {
    DashboardIcon, KanbanIcon, ArchiveIcon, GroupIcon, ProjectIcon, QuoteIcon, ToolIcon
} from '../ui/Icons';

const Sidebar = ({ view, onViewChange, onCloseDetails, isCollapsed }) => {
    const menuItems = [
        { id: 'dashboard', label: 'Dashboard', icon: DashboardIcon },
        { id: 'flow', label: 'O Fluxo', icon: KanbanIcon },
        { id: 'projects', label: 'Projetos', icon: ProjectIcon },
        { id: 'clients', label: 'Clientes', icon: GroupIcon },
        { id: 'quotes', label: 'Orçamentos', icon: QuoteIcon },
        { id: 'tools', label: 'Ferramentas', icon: ToolIcon },
        { id: 'archived', label: 'Arquivadas', icon: ArchiveIcon },
    ];

    const handleViewChange = (newView) => {
        if (onCloseDetails && typeof onCloseDetails === 'function') {
            onCloseDetails();
        }
        onViewChange(newView);
    };

    return (
        <aside className={`fixed top-0 bottom-0 bg-gray-100/80 dark:bg-white/10 backdrop-blur-lg border-r border-gray-200/80 dark:border-white/20 text-gray-800 dark:text-white shadow-lg z-30 pt-20 transition-all duration-300 ease-in-out ${isCollapsed ? 'w-20' : 'w-64'} hidden md:block`}>
            <nav className="p-4">
                <ul className="space-y-2">
                    {menuItems.map(item => (
                        <li key={item.id}>
                            <button
                                onClick={() => handleViewChange(item.id)}
                                className={`w-full flex items-center p-3 rounded-lg transition-colors duration-200 ${
                                    view === item.id ? 'bg-indigo-500 text-white' : 'hover:bg-black/5 dark:hover:bg-white/20'
                                } ${isCollapsed ? 'justify-center' : ''}`}
                                title={isCollapsed ? item.label : ''}
                            >
                                <item.icon size={24} className="flex-shrink-0" />
                                
                                <span className={`ml-4 text-sm font-medium whitespace-nowrap transition-all duration-300 ${isCollapsed ? 'opacity-0 w-0' : 'opacity-100 w-auto'}`}>
                                    {item.label}
                                </span>

                            </button>
                        </li>
                    ))}
                </ul>
            </nav>
        </aside>
    );
};

export default Sidebar;